import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";

@Component({
    selector: 'app-place',
    templateUrl: './place.component.html'
})
export class PlaceComponent implements OnInit {

    public slug;
    public place = {
        id: '',
        title: '',
        content: '',
        cover_image: ''
    };
    attractions = [];
    events = [];
    blogs = [];

    constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {

    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
        });

        this.http.get(Conf.API_URL + '/places/?slug=' + this.slug).subscribe(
            data => {
                this.place = data['results'][0];
                this.getAttractions();
                this.getBeInspired();
                this.getWhatsOn();
            },
            error => {
                console.log(error.error)
            }
        );
    }


    getAttractions() {
        this.http.get(Conf.API_URL + '/get-attractions/?place=' + this.place.id).subscribe(
            data => {
                this.attractions = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );

    }


    getBeInspired() {
        this.http.get(Conf.API_URL + '/get-blogs/?place=' + this.place.id).subscribe(
            data => {
                this.blogs = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getWhatsOn() {
        this.http.get(Conf.API_URL + '/get-events/?place=' + this.place.id).subscribe(
            data => {
                this.events = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/places-to-go/place.component.ts